export const SHOW_ON_MAP = "Show on Map";
